/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { spotlight_mobile } from '../models/spotlight_mobile';
import type { spotlight_track } from '../models/spotlight_track';
import type { spotlight_web } from '../models/spotlight_web';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpotlightService {
    /**
     * Track an event on spotlight for a member.
     *
     * @param track
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static postSpotlightsTracking(
        track: spotlight_track,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/spotlights/tracking',
            body: track,
        });
    }
    /**
     * Get  `Spotlights Mobile` paginated list.
     *
     * @param retailerId Retailer identifier
     * @param memberId Member identifier
     * @param partnerId Partner identifier
     * @param categoryId Category identifier
     * @param storeId Store identifier permits to apply product carried `!!JP ONLY!!`
     * @param datePc Date format YYYYMMDD
     * @returns spotlight_mobile Successful operation, returning spotlights.
     * @throws ApiError
     */
    public static getSpotlightsMobile(
        retailerId?: number,
        memberId?: number,
        partnerId?: number,
        categoryId?: number,
        storeId?: number,
        datePc?: string,
    ): CancelablePromise<Array<spotlight_mobile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/spotlights/mobile',
            query: {
                'retailer_id': retailerId,
                'member_id': memberId,
                'partner_id': partnerId,
                'category_id': categoryId,
                'store_id': storeId,
                'date_pc': datePc,
            },
        });
    }
    /**
     * Get  `Spotlights Mobile`.
     *
     * @param spotlightId Spotlight identifier
     * @param retailerId Retailer identifier
     * @param memberId Member identifier
     * @returns spotlight_mobile Successful operation, returning spotlights.
     * @throws ApiError
     */
    public static getSpotlightsMobile1(
        spotlightId: number,
        retailerId?: number,
        memberId?: number,
    ): CancelablePromise<spotlight_mobile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/spotlights/mobile/{spotlight_id}',
            path: {
                'spotlight_id': spotlightId,
            },
            query: {
                'retailer_id': retailerId,
                'member_id': memberId,
            },
        });
    }
    /**
     * Get  `Spotlights Web` paginated list.
     *
     * @returns spotlight_web Successful operation, returning spotlights.
     * @throws ApiError
     */
    public static getSpotlightsWeb(): CancelablePromise<Array<spotlight_web>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/spotlights/web',
        });
    }
    /**
     * Get  `Spotlights Web`.
     *
     * @param spotlightId Spotlight identifier
     * @returns spotlight_web Successful operation, returning spotlights.
     * @throws ApiError
     */
    public static getSpotlightsWeb1(
        spotlightId: number,
    ): CancelablePromise<spotlight_web> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/spotlights/web/{spotlight_id}',
            path: {
                'spotlight_id': spotlightId,
            },
        });
    }
}
